import React from "react";

export const PUBLIC_SLOGAN = "One Hub for Care";

export const publicPageContainerStyle = {
  width: "100%",
  maxWidth: "100%",
  margin: "0 auto",
  padding: "1rem 1.25rem",
} as const;

export const publicHeroCardStyle = {
  background: "linear-gradient(135deg, #fff7ee 0%, #eef6ff 52%, #f9fcff 100%)",
  border: "1px solid #d9e8f5",
  borderRadius: "24px",
  boxShadow: "0 14px 30px rgba(24, 93, 162, 0.07)",
  padding: "1.1rem 1.25rem",
} as const;

export const publicSectionCardStyle = {
  backgroundColor: "#ffffff",
  border: "1px solid #dde9f5",
  borderRadius: "24px",
  boxShadow: "0 14px 32px rgba(24, 93, 162, 0.06)",
  padding: "1.5rem",
} as const;

export const publicAccentCardStyle = {
  background: "linear-gradient(180deg, #fff9f4 0%, #ffffff 100%)",
  border: "1px solid #f4dfca",
  borderRadius: "24px",
  boxShadow: "0 14px 32px rgba(227, 139, 44, 0.08)",
  padding: "1.5rem",
} as const;

export const publicLegalShellStyle = {
  ...publicSectionCardStyle,
  maxWidth: "980px",
  margin: "0 auto",
  lineHeight: 1.8,
  color: "#243447",
} as const;

export const publicLegalHeaderStyle = {
  borderBottom: "1px solid #d9e8f5",
  paddingBottom: "1.25rem",
  marginBottom: "2rem",
  textAlign: "center" as const,
};

export const publicMutedTextStyle = {
  color: "#5f7488",
  lineHeight: 1.75,
} as const;

export const publicSectionHeadingStyle = {
  color: "#0f3d63",
  fontSize: "0.98rem",
  fontWeight: 700,
  letterSpacing: "0.03em",
  paddingBottom: "0.55rem",
  borderBottom: "1px solid #d9e8f5",
  marginTop: "2rem",
} as const;

export const renderPublicSloganHighlight = () => (
  <span
    className="inline-flex align-items-center gap-2 px-2 py-1 border-round-2xl"
    style={{
      background: "linear-gradient(135deg, #fff4e8 0%, #ffffff 100%)",
      border: "1px solid #f2d2b1",
      color: "#0f3d63",
      fontWeight: 700,
      fontSize: "0.84rem",
      boxShadow: "0 8px 18px rgba(227, 139, 44, 0.07)",
    }}
  >
    <i className="pi pi-star-fill" style={{ color: "#e38b2c" }} />
    <span>One Hub for <span style={{ color: "#c76b11" }}>Care</span></span>
  </span>
);

export const renderPublicHero = (
  eyebrow: string,
  title: string,
  subtitle: string,
) => (
  <div style={publicHeroCardStyle}>
    <div
      className="flex flex-wrap align-items-center justify-content-center gap-2 mb-2"
      style={{ rowGap: "0.45rem" }}
    >
      <div
        className="inline-flex align-items-center gap-2 px-2 py-1 border-round-2xl"
        style={{ backgroundColor: "#ffffff", border: "1px solid #f2d2b1", color: "#0f3d63", fontWeight: 700, fontSize: "0.84rem" }}
      >
        <i className="pi pi-check-circle" style={{ color: "#e38b2c", fontSize: "0.8rem" }} />
        {eyebrow}
      </div>
    </div>
    <h1 style={{ color: "#0f3d63", fontSize: "clamp(1.2rem, 2vw, 1.7rem)", lineHeight: 1.18, margin: "0 0 0.4rem" }}>
      {title}
    </h1>
    <p style={{ ...publicMutedTextStyle, fontSize: "0.88rem", maxWidth: "820px", margin: "0 auto" }}>
      {subtitle}
    </p>
  </div>
);

export const renderPublicLegalHeader = (
  title: string,
  metaPrimary: React.ReactNode,
  metaSecondary?: React.ReactNode,
) => (
  <div style={publicLegalHeaderStyle}>
    <h2 style={{ fontSize: "1.2rem", fontWeight: "700", letterSpacing: "0.03em", textTransform: "uppercase", marginBottom: "0.35rem", color: "#0f3d63" }}>
      {title}
    </h2>
    <p style={{ ...publicMutedTextStyle, fontSize: "0.9rem", margin: 0 }}>
      {metaPrimary}
    </p>
    {metaSecondary ? (
      <p style={{ ...publicMutedTextStyle, fontSize: "0.9rem", margin: "0.25rem 0 0" }}>
        {metaSecondary}
      </p>
    ) : null}
  </div>
);
